// 100vwに含まれるスクロールバー幅を除いた表示幅とzoom倍率をCSS変数へ反映 -----
(() => {
	const setViewportWidth = () => {
		const viewportWidth = document.documentElement.clientWidth;

		document.documentElement.style.setProperty("--viewport-width", `${viewportWidth}px`);
		document.documentElement.style.setProperty("--viewport-ratio-1440", viewportWidth / 1440);
		document.documentElement.style.setProperty("--viewport-ratio-375", viewportWidth / 375);
	};

	setViewportWidth();
	requestAnimationFrame(setViewportWidth);
	window.addEventListener("resize", setViewportWidth);
	window.addEventListener("load", setViewportWidth);

	if ("ResizeObserver" in window) {
		const observer = new ResizeObserver(setViewportWidth);
		observer.observe(document.documentElement);

		if (document.body) {
			observer.observe(document.body);
		}
	}
})();

// ヘッダー高さをCSS変数へ反映 -----
document.addEventListener("DOMContentLoaded", () => {
	const header = document.querySelector(".header");

	if (!header) return;

	const setHeaderHeight = () => {
		const height = header.getBoundingClientRect().height;

		document.documentElement.style.setProperty("--header-h", `${height}px`);
	};

	setHeaderHeight();
	window.addEventListener("resize", setHeaderHeight);

	if ("ResizeObserver" in window) {
		const observer = new ResizeObserver(setHeaderHeight);
		observer.observe(header);
	}
});
